function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fffbd0;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_54",
  "data-name": "Group 54",
  transform: "translate(-370.855 -662.702)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  className: "cls-1",
  d: "M383.867,677.344c2.335,0,5.128-6.828,5.128-9.515a5.128,5.128,0,0,0-10.256,0C378.739,670.445,381.588,677.344,383.867,677.344Zm0-13.926a4.415,4.415,0,0,1,4.412,4.411c0,2.8-2.769,8.8-4.412,8.8-1.562,0-4.412-6.169-4.412-8.8A4.416,4.416,0,0,1,383.867,663.418Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  className: "cls-1",
  d: "M386.621,667.837a2.754,2.754,0,1,0-2.754,2.754A2.757,2.757,0,0,0,386.621,667.837Zm-5.031,0a2.277,2.277,0,1,1,2.277,2.276A2.279,2.279,0,0,1,381.59,667.837Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  className: "cls-1",
  d: "M404.839,688.349c-.552-1.258-5.2-11.628-5.234-11.688a1.93,1.93,0,0,0-1.991-1.163c-1.124-.008-7.982,0-7.982,0a.429.429,0,0,0,.038.856s2.751-.045,3.293-.045l2.553,6.428-7.363.055-.776-5.04a.277.277,0,0,0-.312-.228.272.272,0,0,0-.227.311l.765,4.961-7.955.059.926-4.939a.273.273,0,0,0-.536-.1l-.946,5.043-5.613.042c.929-3.119,1.773-5.864,1.962-6.247a.7.7,0,0,1,.572-.346l2.626.027h.005a.409.409,0,0,0,0-.818l-2.63-.028a1.5,1.5,0,0,0-1.311.8c-.444.9-3.436,11.2-3.778,12.386a2.04,2.04,0,0,0,.239,1.638,1.523,1.523,0,0,0,1.28.545H403.51v0h0v0a.566.566,0,0,0,.083-.008,2.029,2.029,0,0,0,1.013-.412C404.991,690.12,405.342,689.491,404.839,688.349Zm-11.288-12.036c1.7,0,3.445,0,4.058,0,.992.005,1.209.574,1.232.635s1.288,2.872,2.577,5.746l-5.316.04Zm2.181,6.972,2.684,6.762h-9.145l-1.034-6.705Zm-8.045.061,1.033,6.7H378.3l1.245-6.641Zm-15.869,6.476a1.253,1.253,0,0,1-.1-.922c.474-1.636,1.045-3.586,1.6-5.448l5.674-.042-1.244,6.637h-5.3A.751.751,0,0,1,371.818,689.822Zm32.367-.121a1,1,0,0,1-.7.346H399l-2.686-6.766,5.343-.04c1.112,2.48,2.183,4.873,2.43,5.437A1.2,1.2,0,0,1,404.185,689.7Z"
}));

var SvgKinnistuObject = function SvgKinnistuObject(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34.234,
    height: 28.163,
    viewBox: "0 0 34.234 28.163",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKinnistuObject, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kinnistu_object.5478c2cc.svg";
export { ForwardRef as ReactComponent };